"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.postFormDataAsJson = exports.formInit = void 0;
function formInit(url) {
    Array.from(document.getElementsByTagName("form")).forEach(async (form) => {
        var _a;
        //only show lower content blocks if tool form has been submitted
        if (form.getAttribute('id') == "wi-form") {
            form.onsubmit = function (event) {
                if (form.checkValidity()) {
                    document.getElementById('wi-tool-lower').classList.remove('d-none');
                }
            };
        }
        if (form.getAttribute('id') != "searchform" && form.getAttribute('id') != "wi-form") {
            if (form.classList.contains('webinar') && localStorage.getItem('curo')) {
                // console.log('webinar form')
                form.innerHTML = '<div style="padding:56.25% 0 0 0" class="position-relative"><div class="position-absolute d-block spinner spinner-large spinner-dust" style="top:25%;"></div></div>';
                // submit a request and replace with video
                let formData = new FormData();
                formData.append('id', localStorage.getItem('curo'));
                formData.append('type', 'webinar');
                formData.append('webinar_id', form.dataset['webinar']);
                submitForm(form, formData, url);
            }
            if (form.classList.contains('download') && localStorage.getItem('curo')) {
                // console.log('download form')
                let formData = new FormData();
                formData.append('id', localStorage.getItem('curo'));
                formData.append('type', 'download');
                const row = form.closest('.row');
                row.classList.add('form-hidden');
                let button = form.querySelector('button');
                button.className = 'et:mt-1.5 et:self-start et:inline-flex et:items-center et:text-secondary et:hover:text-secondary et:bg-midblue et:rounded-full et:no-underline et:transition-all et:duration-150 et:py-2 et:px-3.5 et:font-normal et:group';
                button.innerHTML = 'View unlocked guide <i class="fa-regular fa-arrow-right et:text-sm et:ms-2 et:leading-none et:text-premier et:transition-transform et:duration-150 et:group-hover:translate-x-0.5"></i>';
                button.addEventListener('click', async (event) => {
                    event.preventDefault();
                    if (form.dataset['page']) {
                        formData.append('page_id', form.dataset['page']);
                    }
                    else {
                        formData.append('document_id', form.dataset['document']);
                    }
                    submitForm(form, formData, url);
                });
                form.innerHTML = '';
                form.appendChild(button);
                const heroBanner = document.querySelector('.hero-banner-landing-top');
                if (heroBanner) {
                    if (form.closest('.hero-banner-landing')) {
                        if (window.innerWidth >= 1155) {
                            heroBanner.appendChild(form);
                        }
                    }
                    else {
                        heroBanner.classList.add('unlocked');
                        (_a = document.querySelector('.unlocked-img')) === null || _a === void 0 ? void 0 : _a.classList.add('d-lg-block');
                        heroBanner.appendChild(form);
                    }
                }
            }
            // console.log('other form')
            if (form.classList.contains('download'))
                form.removeAttribute('style');
            form.onsubmit = async (event) => {
                form.classList.add('was-validated');
                if (!form.checkValidity()) {
                    event.preventDefault();
                    event.stopPropagation();
                    return false;
                }
                // disable form buttons
                disableButtons(form);
                // hide any previous message
                let messageEl = document.getElementById('form-message');
                if (messageEl)
                    messageEl.remove();
                event.preventDefault();
                const formData = new FormData(form);
                submitForm(form, formData, url);
                // prevent reload
                return false;
            };
        }
    });
}
exports.formInit = formInit;
// Function to trigger the event with payload
function triggerFormSubmissionEvent(email, leadType) {
    const encodedEmail = btoa(email); // Encoding email to base64
    // Pushing data layer event with payload
    if (window.dataLayer) {
        window.dataLayer.push({
            event: 'form_submission',
            email: encodedEmail,
            lead_type: leadType
        });
    }
}
async function submitForm(form, formData, url) {
    //if name is set split and set firstname/surname for curo
    const name = formData.get('name');
    if (name) {
        const name_string = name.toString().trim();
        var [first_name, last_name] = name_string.includes(' ') ? [name_string.substring(0, name_string.indexOf(' ')), name_string.substring(name_string.indexOf(' ') + 1)] : [name_string, ''];
        formData.append('firstname', first_name);
        formData.append('surname', last_name);
    }
    try {
        const responseData = await postFormDataAsJson(url, formData);
        if (form.classList.contains('form-new_contact') || form.classList.contains('form-consultation')) {
            const email = formData.get('email') || '';
            const phone = formData.get('phone') || '';
            const portfolio = formData.get('portfolio') || '';
            document.dispatchEvent(new CustomEvent('contactFormSuccess', { detail: { email, phone, portfolio } }));
        }
        handleResponse(responseData, form);
    }
    catch (error) {
        let div = document.createElement('div');
        div.className = 'alert bg-premier shadow rounded text-dust';
        div.id = 'form-message';
        div.textContent = error.message;
        if (error.message == 'Id not found') {
            localStorage.removeItem('curo');
            div.textContent = 'There was error completing this request, please refresh the page and try again.';
        }
        form.before(div);
        enableButtons(form);
    }
}
async function postFormDataAsJson(url, formData) {
    let plainFormData = Object.fromEntries(formData.entries());
    if (plainFormData.email && blacklistEmail(plainFormData.email)) {
        throw new Error("There was error completing this request, please refresh the page and try again.");
    }
    // if utm data is in localStorage, merge with formData
    if (localStorage.getItem('utm')) {
        try {
            plainFormData = Object.assign(plainFormData, JSON.parse(localStorage.getItem('utm')));
        }
        catch (error) {
            // ignore, just sends the plainFormData
        }
    }
    // GTM event
    if (plainFormData.email) {
        const leadType = plainFormData.type === 'existing_contact'
            ? 'existing_client'
            : plainFormData.portfolio && plainFormData.portfolio !== 'N/A'
                ? 'qualified'
                : 'general';
        triggerFormSubmissionEvent(plainFormData.email, leadType);
    }
    let formDataJsonString = JSON.stringify(plainFormData);
    let fetchOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
        },
        body: formDataJsonString,
    };
    let response = await fetch(url, fetchOptions);
    if (!response.ok) {
        let errorMessage = await response.text();
        throw new Error(errorMessage);
    }
    return response.json();
}
exports.postFormDataAsJson = postFormDataAsJson;
function handleResponse(responseData, form) {
    // add success message to replace form
    form.classList.add('form-success');
    let div = document.createElement('div');
    div.id = 'form-message';
    // handle the responseData 
    if (responseData.document) {
        div.className = 'alert bg-dark text-light rounded shadow form-message-asset';
        //div.innerHTML = 'Thank you, your requested guide should download as a PDF, or you can <a class="text-light" href="'+responseData.document+'" target="_blank">click here</a>'
        div.textContent = 'Thank you, you can now view the requested content';
        setTimeout(() => {
            window.location.href = responseData.document;
        }, 1000);
    }
    else if (responseData.url) {
        window.location.href = responseData.url;
        div.className = 'alert bg-dark text-light rounded shadow ' + responseData.message_class;
        //div.textContent = 'Thank you, you\'ll be redirected to the requested content'
        div.textContent = 'Thank you, you can now view the requested content';
    }
    else if (responseData.webinar) {
        div.className = 'form-message-asset';
        div.innerHTML = `
        <div style="padding:56.25% 0 0 0" class="position-relative"><iframe title="Video" src="https://player.vimeo.com/video/${responseData.webinar}?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;h=e3495cf78d" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;"></iframe></div>`;
    }
    else {
        div.className = 'alert bg-dark text-light rounded shadow';
        div.textContent = 'Thank you for taking the time to get in touch. We’ll get back to you as soon as possible.';
    }
    console.log('responseData before ID test', responseData);
    if (responseData.id) {
        const itemSet = (localStorage.getItem('curo') !== null);
        if (itemSet) {
            // do nothing
        }
        else {
            localStorage.setItem('curo', responseData.id);
        }
    }
    form.before(div);
    form.classList.remove('was-validated');
    form.reset();
    // remove the form from the page, prevent resubmit with same nonce
    form.remove();
    enableButtons(form);
}
function disableButtons(form) {
    Array.from(form.getElementsByTagName('button')).forEach(button => {
        button.setAttribute('disabled', 'disabled');
    });
}
function enableButtons(form) {
    Array.from(form.getElementsByTagName('button')).forEach(button => {
        button.removeAttribute('disabled');
    });
}
function blacklistEmail(email) {
    const client = email.split("@");
    const match = client[1].match(/(mailinator\.)/);
    return match;
}
const elements = document.querySelectorAll("INPUT, TEXTAREA");
//console.log(elements,'els')
for (var i = 0; i < elements.length; i++) {
    var el = elements[i];
    el.addEventListener('invalid', function (event) {
        var target = event.target;
        if (target.validity.patternMismatch && !target.validity.valueMissing) {
            target.parentElement.classList.add('invalid-pattern');
        }
    });
    el.addEventListener('change', function (event) {
        var target = event.target;
        if (target.validity.patternMismatch && !target.validity.valueMissing) {
            target.parentElement.classList.add('invalid-pattern');
        }
        if (!target.validity.patternMismatch) {
            target.parentElement.classList.remove('invalid-pattern');
        }
    });
}
